import _axios from '../..'
import { IndicatorType } from 'src/types'

export const CompanyIndicatorTypeService = {
  update: async (
    id: IndicatorType['id'],
    body: Partial<IndicatorType>
  ): Promise<IndicatorType> =>
    (await _axios.patch(`/indicator_type/${id}`, body)).data,

  create: async (body: Partial<IndicatorType>): Promise<IndicatorType> =>
    (await _axios.post(`/indicator_type`, body)).data,

  get: async (): Promise<IndicatorType[]> =>
    (await _axios.get(`/indicator_type`)).data,
}

export default CompanyIndicatorTypeService
